import moment from 'moment';
import { getProjectPhases } from '../../HttpRequests/projectPhases';
import { loadProjectPhases } from '../State/projectPhases';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getProjectPhases();

    dispatch(loadProjectPhases(response.data.data));

  } catch (error) {
    
    throw error;

  }
}